import React, { useEffect, useState } from "react";
import "../create/Host_Detail_Create.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import Success_Modal from "../../../common_components/common-modal/success_modal/Success_Modal";

import {
  AddHost,
  GetAllHost,
  GetHost,
  UpdateHost,
} from "../../../../features/admin/host/slice";
import { useDispatch, useSelector } from "react-redux";
import { AllRoles } from "../../../../features/admin/common/Slice";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faL } from "@fortawesome/free-solid-svg-icons";

const Host_Detail_Edit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);

  const { id } = useParams();

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm: false,
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    // defaultValues: {
    //   host_id: null,
    //   user_name: "",
    //   user_id: "",
    //   reference: "",
    //   role_id: null,
    // },
  });

  const newPassword = watch("password", "");

  const allRolesData = useSelector((state) => state.common.all_roles);

  useEffect(() => {
    dispatch(AllRoles());
  }, [dispatch]);

  const GetData = async (hostId) => {
    try {
      const res = await dispatch(GetHost(hostId)).unwrap();

      const hostData = res?.data;

      if (!hostData) {
        return;
      }

      reset({
        user_name: hostData?.user_name || "",
        app_id: hostData?.app_id || "",
        email: hostData?.email || "",
        contact_no: hostData?.contact_no || "",
        password: hostData?.password || "",
        confirm_password: hostData?.password || "",
        app_link: hostData?.app_link || "",
        call_back_secret: hostData?.call_back_secret || "",
        server_secret: hostData?.server_secret || "",
        app_sign: hostData?.app_sign || "",
        app_id: hostData?.app_id || "",
        role_id: hostData?.role_id
          ? {
              value: hostData.role_id.value,
              label: hostData.role_id.label,
            }
          : null,
      });
    } catch (error) {
      console.error("Get Host Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      GetData(Number(id));
    }
  }, [id]);

  const togglePasswordVisibility = (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        user_name: data.user_name,
        app_id: data.app_id,
        app_sign: data.app_sign,
        server_secret: data.server_secret,
        call_back_secret: data.call_back_secret,
        app_link: data.app_link,
        password: data.password,
        role_id: data.role_id,
        email: data.email,
        contact_no: data.contact_no,
      };
      const res = await dispatch(
        UpdateHost({ id: id, data: payload }),
      ).unwrap();

      if (res.success) {
        dispatch(GetAllHost());
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          navigate(-1);
        }, 3000);
      }
    } catch (error) {
      console.error("Add Host Error:", error);
    }
  };

  return (
    <section className="Student_Detail_Create common_section">
      <div className="section_filter_div">
        <p className="filter_title">Edit Host</p>
      </div>

      <div className="host-user-card">
        <div className="form-ro">
          <div className="form-control-wrapper1">
            <button
              type="button"
              className="submit-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <br />
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper-div">
          {/* User Name */}
          <div className="form-row">
            <label className="form-label">
              Users Name <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Users Name"
                className="form-input"
                {...register("user_name", {
                  required: "Users Name is required",
                })}
              />

              {errors.user_name && (
                <span className="text-danger">{errors.user_name.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              User Email <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="User Email"
                className="form-input"
                {...register("email", {
                  required: "User Email is required",
                })}
              />
              {errors.email && (
                <span className="text-danger">{errors.email.message} </span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              User Contact No <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="User Contact No"
                className="form-input"
                maxLength={10}
                {...register("contact_no", {
                  // required: "User Contact No is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Contact number must be exactly 10 digits",
                  },
                })}
              />

              {errors.contact_no && (
                <span className="text-danger">{errors.contact_no.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              App Id <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="App Id"
                className="form-input"
                {...register("app_id", { required: "App ID is required" })}
              />
              {errors.app_id && (
                <span className="text-danger"> {errors.app_id.message} </span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              App Sign <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="App Sign"
                className="form-input"
                {...register("app_sign", { required: "App Sign is required" })}
              />
              {errors.app_sign && (
                <span className="text-danger"> {errors.app_sign.message} </span>
              )}
            </div>
          </div>
          {/* Server Secret */}
          <div className="form-row">
            <label className="form-label">
              Server Secret <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Server Secret"
                className="form-input"
                {...register("server_secret", {
                  required: "Server Secret is required",
                })}
              />
              {errors.server_secret && (
                <span className="text-danger">
                  {errors.server_secret.message}
                </span>
              )}
            </div>
          </div>
          {/* Call Back Secret */}
          <div className="form-row">
            <label className="form-label">
              Call Back Secret <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Call Back Secret"
                className="form-input"
                {...register("call_back_secret", {
                  required: "Call Back Secret is required",
                })}
              />
              {errors.call_back_secret && (
                <span className="text-danger">
                  {errors.call_back_secret.message}
                </span>
              )}
            </div>
          </div>
          {/* App Link */}
          <div className="form-row">
            <label className="form-label">
              App Link <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="App Link"
                className="form-input"
                {...register("app_link", {
                  //  required: "App Link is required"
                })}
              />
              {errors.app_link && (
                <span className="text-danger"> {errors.app_link.message} </span>
              )}
            </div>
          </div>
          {/* New Password */}
          <div className="form-row">
            <label className="form-label">
              Password <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <Form.Group>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword.password ? "text" : "password"}
                    placeholder="Enter Password"
                    {...register("password", {
                      required: " Password is required",
                    })}
                    className={errors.password ? "is-invalid" : ""}
                  />
                  <FontAwesomeIcon
                    icon={showPassword.password ? faEye : faEyeSlash}
                    className="password-toggle-icon"
                    onClick={() => togglePasswordVisibility("password")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {errors.password && (
                  <Form.Text className="text-danger">
                    {errors.password.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
          {/* Confirm Password */}
          <div className="form-row">
            <label className="form-label">
              Confirm New Password <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <Form.Group>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword.confirm ? "text" : "password"}
                    placeholder="Enter Confirm Password"
                    {...register("confirm_password", {
                      required: "Confirm Password is required",
                      validate: (value) =>
                        value === newPassword || "Passwords do not match",
                    })}
                    className={errors.confirm_password ? "is-invalid" : ""}
                  />
                  <FontAwesomeIcon
                    icon={showPassword.confirm ? faEye : faEyeSlash}
                    className="password-toggle-icon"
                    onClick={() => togglePasswordVisibility("confirm")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {errors.confirm_password && (
                  <Form.Text className="text-danger">
                    {errors.confirm_password.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Role <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <Controller
                name="role_id"
                control={control}
                rules={{ required: "Role is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={allRolesData}
                    onInputChange={(val) => {
                      dispatch(AllRoles(val));
                    }}
                  />
                )}
              />
              {errors.role_id && (
                <Form.Text className="text-danger">
                  {errors.role_id.message}
                </Form.Text>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-label"></div>

            <div className="form-control-wrapper">
              <button type="submit" className="submit-btn">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>

      <Success_Modal
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
          navigate(-1);
        }}
      />
    </section>
  );
};

export default Host_Detail_Edit;
